import GuiContext from 'config/context/guiContext';
import PluginsContext from 'config/context/pluginsContext';
import { useContext, useMemo } from 'react'

const useIsPluginActive = (pluginId) => {
  const {
    userData: { guiname },
  } = useContext(GuiContext);

  const { getActiveByAccountName } = useContext(PluginsContext);

  return useMemo(() => {
    const activePlugins = getActiveByAccountName(guiname)?.active ?? [];
    return activePlugins.includes(pluginId);
  }, [guiname, getActiveByAccountName, pluginId]);
}

export default useIsPluginActive;